import { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';
import { DialogConfigOptions } from '@core/user-interface-legacy';

export interface SlotsLimitDialogOpener {
  open: (
    config: DialogConfigOptions | null,
    data: {
      showSaveAsDraft?: boolean;
      isTrial?: boolean;
      skipRedirectAfterPurchase?: boolean;
      triggeredFromBulkCount?: number;
    },
  ) => Observable<boolean | null>;
}

export const {
  provide: provideSlotsLimitDialogOpenerContract,
  inject: injectSlotsLimitDialogOpenerContract,
} = createProviderToken<SlotsLimitDialogOpener>('SlotsLimitDialogOpener')();
